import React from 'react'
import { VEC_ICON_NAME } from "../../icons/constants";
import styles from "./CardWTopRightIcon.styles"
import Icons from '../../icons/Icons';
import Heading from '../../heading/Heading';
import { HEADING } from '../../heading/constants/constants';
import BasicCard from '../basiccard/BasicCard';
import Button from '../../button/Button';

const CardWTopRightIcon = ({
    topLeftIcon = { icon: "", title: "", selected: false },
    isSelected = false,
    isFullWidth = true,
    setDefaultCb = () => {},
    isEditable = false,
    children,
}) => {
    return (
        <BasicCard fullWidth={isFullWidth} isHighlighted={isSelected} isHighlightedIcon=''>
            {topLeftIcon.icon &&
                <div style={styles.topLeftIcon} title={topLeftIcon.title}>
                    {topLeftIcon.selected ?
                        <Icons familyName={"vec"} iconName={topLeftIcon.icon || VEC_ICON_NAME.INFO_ICON} />
                        : isEditable && <span style={styles.pointer} onClick={setDefaultCb}>Set as Default</span>
                    }
                </div>
            }
            {children}
        </BasicCard>
    )
}

export default CardWTopRightIcon